import React, { ReactElement, useEffect, useRef, useState } from 'react';
import './KodanshaAvailable.scss';
import PLUS from '../../Assets/icons/PLUS.svg';
import MINUS from '../../Assets/icons/MINUS.svg';
import { AssetLinkGroup } from '../../../Models/AssetLinkGroup';
import { scrollToElement, scrollToItem } from '../../../utils/utils';
import { useAtom } from 'jotai';
import { AnalyticsIdAtom, AnalyticsUserProxyAtom } from '../../../store/AnalyticsStore';
import apiClient from '../../../API/InkyAPI';
import AnalyticsEvent from '../../../Models/Analytics/AnalyticsEvent';
import ReactGA from 'react-ga4';
import Log from '../../Services/Logger';
import { AccountInfoAtom } from '../../../store/AccountStore';

interface KodanshaAvailableProps {
    items: AssetLinkGroup[];
    scrollTo?: boolean;
    also?: boolean;
    text?: string;
}

const KodanshaAvailable = ({ items, scrollTo = false, also = true, text }: KodanshaAvailableProps): ReactElement => {
    const availableRef = useRef(null);
    Log.debug('alsoalso', also);

    useEffect(() => {
        if (scrollTo) {
            setTimeout(() => {
                scrollToItem(availableRef.current, 100);
            }, 100);
        }
    }, []);

    if (items.length == 0)
        return null;

    if (items.every((item) => item.assetLinks.length == 0))
        return null;


    return (
        <div className='available-container' ref={availableRef}>
            <span className='available-title'>{text ? text : also ? 'Also available on' : 'Available on'}</span>
            <div className='available-divider' />


            <div className='available-items-wrapper'>
                {items?.map((item) => {
                    return <AssetLinkButtonGroup key={item.name} item={item} />;
                })}
            </div>
        </div>
    );
};

interface AssetLinkButtonGroupProps {
    item: AssetLinkGroup;
}

 export const AssetLinkButtonGroup = ({ item }: AssetLinkButtonGroupProps): ReactElement => {
    const [printArray, setPrintArray] = useState(false);
    const [sessionId] = useAtom(AnalyticsIdAtom);
    const [accountInfo] = useAtom(AccountInfoAtom);
    const [analyticsUserProxy] = useAtom(AnalyticsUserProxyAtom);

    function trackAnalyticsLink(assetLink): void {
        console.log(assetLink);
        if (assetLink.type === 'ExternalUrl') {
            ReactGA.event('k_partner_link_click', assetLink);
            apiClient.sendEvent(accountInfo,new AnalyticsEvent(sessionId.toString(), 'VISIT_EXTERNAL_STORE', window.location.pathname, assetLink.name, analyticsUserProxy.toString()))
                .then(res => {
                    console.log(res);
                }).catch(e => {
                console.error(e);
            });
        }
    }

    return <React.Fragment key={item.name}>
        <div className='available-item-wrapper' onClick={() => {
            if (!printArray)
                setPrintArray(true);
            else
                setPrintArray(false);
        }}>
            <span className='available-item-title'>{item.name}</span>
            <span className='available-item-plus'>
                {!printArray && <img alt={'Expand'} src={PLUS} />}
                {printArray && <img alt={'Collapse'} src={MINUS} />}
            </span>
        </div>
        <div className={`expandable-row ${printArray && 'expandable-row-active'}`}>
            {item.assetLinks.map((assetLink) => {
                return (<div key={assetLink.name} className={'available-item-asset-link'}>
                    <a href={assetLink.url} target={'_blank'}
                       onClick={() => trackAnalyticsLink(assetLink)}>{assetLink.name}</a>
                </div>);
            })}
        </div>
        <div className='available-divider' />
    </React.Fragment>;
};

export default KodanshaAvailable;
